import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banners/banner1.jpg';
import banner2 from '../assets/banners/banner2.jpg';
import banner3 from '../assets/banners/banner3.png';
import s1 from '../assets/med/s1.jpg';
import s2 from '../assets/med/s2.jpg';
import s3 from '../assets/med/s3.jpg';
import s4 from '../assets/med/s4.jpg';
import s5 from '../assets/med/s5.jpg';
import s6 from '../assets/med/s6.jpg';
import s7 from '../assets/med/s7.jpg';
import s8 from '../assets/med/s8.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import OneService from "./OneService";
import medical_pic from '../assets/medical_pic.jpg';
import education_pic from '../assets/education_pic.jpg';
import moble_pic from '../assets/mobile_pic.png';
import realestate_pic from '../assets/realestate_pic.jpeg';
import telecom_pic from '../assets/telecom_pic.jpg';
import ict_pic from '../assets/ict_pic.jpeg';
import agri_pic from '../assets/agri_pic.jpeg';
import energ_pic from '../assets/energ_pic.jpeg';
import green_pic from '../assets/green_pic.jpeg';

export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					
				

					

					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Our Products & Services
								<span
									style={{
										display: "block",
										borderBottom: "3px solid var(--secondaryColor)",
										width: "50px",
										marginTop: "10px"
									}}
								>

								</span>
							</h6>
						</div>

						<div className="col-md-12 mb-1 mt-1">
							<OneService
								title="Medical Gas Systems & Supply"
								image={s6}
								navToLink={{
									item: 'services',
									subItem: 'medical_gas_systems'
								}}
							/>
						</div>


						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Radiology Equipments"
								image={s1}
								navToLink={{
									item: 'services',
									subItem: 'radiology_equipments'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Operation Room Assembly"
								image={s2}
								navToLink={null}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="ICU Room Assembly"
								image={s3}
								navToLink={null}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Gas, Welding and cutting"
								image={banner2}
								navToLink={null}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="HDU Room Assembly"
								image={s4}
								navToLink={null}
							/>
						</div>
						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
